//** Import Modules */
import {
  Space,
  Table,
  Tooltip,
  Tag,
  Collapse,
  Empty,
  Button,
  Grid,
  Pagination,
} from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { FE_URL, TABLE_DATE_FORMAT } from "../../../../common/constants";
import { getBusinessList } from "../../../../features/reducers/business";
import { useManageCreateBusinessItems } from "../../../../hooks/useManageCreateBusinessItems";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import BusinessVerification from "./BusinessVerification";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faEdit,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";

export default function MyBusinesses({ user }) {
  const businessList = useSelector((state) => state.business.businessList);
  const navigate = useNavigate();

  const { Panel } = Collapse;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const hookData = {
    ownerID: user.id,
    dispatchAction: getBusinessList(),
    itemType: "business",
    modalData: {
      title: "Create New Business",
      fieldLabel: "Business Name",
    },
  };

  const [modalComponent, CreateItemButton] =
    useManageCreateBusinessItems(hookData);

  const manageBusiness = (id) => {
    localStorage.setItem("editBusiness", id);
    window.location.replace("/business");
  };

  const dispatch = useDispatch();

  const deleteBusiness = (id) => {
    if (window.confirm("Are you sure you wish to delete this item?")) {
      const APIURL = `/api/business/${id}`;
      axiosWithAuth()
        .delete(APIURL)
        .then((res) => {
          dispatch(getBusinessList());
          console.log(res.data, APIURL);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <Helmet>
        <title>My Businesses - BIZZLL Dashboard</title>
      </Helmet>

      <Routes>
        <Route
          path="/"
          element={
            <>
              {businessList.length > 0 ? (
                <>
                  {screens.md ? (
                    <Table
                      columns={[
                        {
                          title: "Name",
                          key: "ad_name",
                          render: (text) => <>{text.name}</>,
                        },
                        {
                          title: "Date Created",
                          key: "created",
                          render: (text) => (
                            <>
                              {moment(new Date(text && text.created)).format(
                                TABLE_DATE_FORMAT
                              )}
                            </>
                          ),
                        },
                        {
                          title: "Last Modified",
                          key: "modified",
                          render: (text) => (
                            <>
                              {moment(new Date(text && text.modified)).format(
                                TABLE_DATE_FORMAT
                              )}
                            </>
                          ),
                        },
                        {
                          title: "Status",
                          key: "status",
                          render: (text) => (
                            <>
                              {text.activated === 0 && (
                                <Tag
                                  icon={<SyncOutlined spin />}
                                  color="processing"
                                >
                                  Pending Approval
                                </Tag>
                              )}
                              {text.activated === 1 && (
                                <Tag
                                  icon={<CheckCircleOutlined />}
                                  color="success"
                                >
                                  Approved
                                </Tag>
                              )}
                              {text.activated === 2 && (
                                <Tag
                                  icon={<ExclamationCircleOutlined />}
                                  color="warning"
                                >
                                  Pending changes
                                </Tag>
                              )}
                              {text.activated === 3 && (
                                <Tag
                                  icon={<CloseCircleOutlined />}
                                  color="error"
                                >
                                  Business denied/cancelled
                                </Tag>
                              )}
                            </>
                          ),
                        },
                        {
                          title: "Action",
                          key: "action",
                          render: (text) => (
                            <Space size="middle">
                              {text.activated !== 1 && text.activated !== 3 && (
                                <button
                                  type="primary"
                                  onClick={() => navigate(`${text.id}`)}
                                >
                                  <FontAwesomeIcon icon={faClipboardCheck} />{" "}
                                </button>
                              )}
                              {text.activated === 1 && text.activated !== 3 && (
                                <button
                                  type="primary"
                                  onClick={() => manageBusiness(`${text.id}`)}
                                >
                                  <Tooltip title="Edit">
                                    <FontAwesomeIcon icon={faEdit} />
                                  </Tooltip>{" "}
                                </button>
                              )}
                              <button
                                type="primary"
                                onClick={() => deleteBusiness(text.id)}
                              >
                                <Tooltip title="Delete">
                                  <FontAwesomeIcon icon={faTrashAlt} />
                                </Tooltip>{" "}
                              </button>
                            </Space>
                          ),
                        },
                      ]}
                      dataSource={businessList}
                    />
                  ) : (
                    <Collapse style={{ marginBottom: "15px" }} accordion>
                      {businessList.map((item) => (
                        <Panel
                          key={item.id}
                          header={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span>
                                {item.name} -{" "}
                                {moment(new Date(item.created)).format(
                                  TABLE_DATE_FORMAT
                                )}
                              </span>
                              {item.activated === 0 && (
                                <Tag color="processing">
                                  <SyncOutlined spin />
                                </Tag>
                              )}
                              {item.activated === 1 && (
                                <Tag color="success">
                                  <CheckCircleOutlined />
                                </Tag>
                              )}
                              {item.activated === 2 && (
                                <Tag color="warning">
                                  <ExclamationCircleOutlined />
                                </Tag>
                              )}
                              {item.activated === 3 && (
                                <Tag color="error">
                                  <CloseCircleOutlined />
                                </Tag>
                              )}
                            </div>
                          }
                        >
                          <p>
                            <strong>Last Modified:</strong>{" "}
                            {moment(new Date(item.modified)).format(
                              TABLE_DATE_FORMAT
                            )}
                          </p>
                          <p>
                            <strong>Status:</strong>{" "}
                            {item.activated === 0 && (
                              <Tag
                                icon={<SyncOutlined spin />}
                                color="processing"
                              >
                                Pending Approval
                              </Tag>
                            )}
                            {item.activated === 1 && (
                              <Tag
                                icon={<CheckCircleOutlined />}
                                color="success"
                              >
                                Approved
                              </Tag>
                            )}
                            {item.activated === 2 && (
                              <Tag
                                icon={<ExclamationCircleOutlined />}
                                color="warning"
                              >
                                Pending changes
                              </Tag>
                            )}
                            {item.activated === 3 && (
                              <Tag icon={<CloseCircleOutlined />} color="error">
                                Business denied/cancelled
                              </Tag>
                            )}
                          </p>
                          <Space size="middle">
                            {item.activated !== 1 && item.activated !== 3 && (
                              <Button
                                type="primary"
                                onClick={() => navigate(`${item.id}`)}
                              >
                                <FontAwesomeIcon icon={faClipboardCheck} />{" "}
                              </Button>
                            )}
                            {item.activated === 1 && item.activated !== 3 && (
                              <Button
                                type="primary"
                                onClick={() => manageBusiness(`${item.id}`)}
                              >
                                <Tooltip title="Edit">
                                  <FontAwesomeIcon icon={faEdit} />
                                </Tooltip>{" "}
                              </Button>
                            )}
                            <Button
                              type="primary"
                              onClick={() => deleteBusiness(item.id)}
                            >
                              <Tooltip title="Delete">
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </Tooltip>{" "}
                            </Button>
                          </Space>
                        </Panel>
                      ))}
                    </Collapse>
                  )}
                </>
              ) : (
                <>
                  <h2>
                    You have no businesses. You may create 1 by clicking the
                    button below, or you can search{" "}
                    <a href={`${FE_URL}/directory`}>our directory</a> to claim
                    your business, if applicable.
                  </h2>
                </>
              )}
              <CreateItemButton btnText="Register Business" />
              {modalComponent}
            </>
          }
          exact
        />
        <Route path=":id" element={<BusinessVerification />} exact />
      </Routes>
    </>
  );
}
